<!--
     Copyright (c) 2022-2025 Broadcom. All Rights Reserved.
     Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
     and/or its subsidiaries.
-->
<div class="versions">
    <div [ngClass]="!version_collapsed ? 'short' : 'overlay'"
         id="versions-expand-button"
         tabindex="0"
         aria-expanded="false"
         aria-controls="versions-desc"
         [attr.aria-label]="'general.build.versions' | vtranslate"
         role="button"
         (keyup.enter)="toggleVersion()"
         (keyup.space)="toggleVersion()"
         (click)="toggleVersion()">
        <small *ngIf="!version_collapsed">
            <div *ngFor="let version of versions">
                ({{version.gitCommit}}) <strong>{{version.buildVersion}}</strong>
            </div>
        </small>
        <cds-icon shape="angle-double"
                  [direction]="!version_collapsed ? 'up' : 'down'"
                  [attr.aria-hidden]="true"></cds-icon>
    </div>
    <div *ngIf="version_collapsed">
        <div class="full"
             id="versions-desc"
             tabindex="0"
             *ngFor="let version of versions">
            <strong>{{version.typeName | vtranslate}}</strong>
            <span><strong>{{version.buildVersion}}</strong></span>
            <small>{{version.buildDate}}</small>
            <small>{{version.gitCommit}}
                <cds-icon shape="arrow"
                          direction="right"
                          [attr.aria-hidden]="true"></cds-icon>
                {{version.gitBranch}}</small>
        </div>
    </div>
</div>
